import { useEffect } from "react";

/**
 * Liga botões/links do HTML original ao seu checkout.
 * Usa .buy-btn ou data-sku/data-checkout.
 * Ex.: <a class="buy-btn" data-sku="LC-CP-VOL1">Comprar</a>
 */
export default function useCheckoutLink({
  fallbackSku = "LC-CP-VOL1",
  checkoutPath = "/checkout",
} = {}) {
  useEffect(() => {
    const handler = (ev) => {
      const a = ev.target.closest("a,button");
      if (!a) return;
      const isBuy = a.matches(".buy-btn, [data-sku], [data-checkout]");
      if (!isBuy) return;
      ev.preventDefault();
      const sku = a.getAttribute("data-sku") || fallbackSku;
      const href = `${checkoutPath}?sku=${encodeURIComponent(sku)}`;
      window.location.href = href;
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [fallbackSku, checkoutPath]);
}
